import {polyfill} from 'es6-promise';
polyfill();

import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import onboarding from './modules/onboarding'

Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		isLoading: false
	},
	actions: {
		CHANGE_LOADING_STATE({ commit, state }, newState) {
			(typeof newState !== 'undefined') ?
				commit('SET_LOADING_STATE', newState) :
				commit('SET_LOADING_STATE', !state.isLoading);
		}
	},
	mutations: {
		SET_LOADING_STATE(state, newState) {
			state.isLoading = newState;
		}
	},
	getters: {},
	modules: {
		user,
		onboarding
	}
});

export default store;